import { HTTP_METHODS } from "../../../../Common/modules/DataProvider/constants/DataProvider.constants";
import { customRequest } from "../../../../Common/modules/DataProvider/utils/DataProvider.utils";
import {
  fetch_appointment_listing_details_api,
  fetch_available_sessions_api,
  reschedule_appointment_session_api,
  schedule_appointment_session_api,
} from "../constants/Appointments.apis";
import { IAppointments } from "../IAppointments";

export const fetchAppointmentListingDetails = ({
  listingUuid,
}: IAppointments.IAppointmentListingDetailsProps) => {
  return customRequest<IAppointments.IAppointmentListingDetailsResponse>({
    endpoint: fetch_appointment_listing_details_api,
    payload: {
      listing_uuid: listingUuid,
    },
  });
};

export const fetchAvailableSlots = ({
  listingUuid,
  startDateTime,
  endDateTime,
}: IAppointments.IAvailableSlotsProps) => {
  return customRequest<IAppointments.IAvailableSlotsResponse>({
    endpoint: fetch_available_sessions_api,
    payload: {
      listing_uuid: listingUuid,
      start_datetime__gte: startDateTime,
      start_datetime__lte: endDateTime,
    },
  });
};
export const scheduleAppointmentCall = ({
  isReschedule,
  payload,
}: IAppointments.IScheduleAppointmentProps) => {
  return customRequest({
    endpoint: isReschedule
      ? reschedule_appointment_session_api
      : schedule_appointment_session_api,
    method: HTTP_METHODS.POST,
    payload: payload,
  });
};
